var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIconW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7652 33.1461C18.4971 33.8779 19.685 33.8779 20.4169 33.1461L29.9437 23.6192L29.9437 29.6989C29.9437 30.1963 30.1413 30.6733 30.493 31.0249C30.8447 31.3766 31.3216 31.5742 31.819 31.5742C32.3163 31.5742 32.7933 31.3766 33.145 31.0249C33.4967 30.6733 33.6942 30.1963 33.6942 29.6989V19.0923C33.6943 18.8461 33.6458 18.6022 33.5515 18.3747C33.4573 18.1471 33.3192 17.9404 33.145 17.7663C32.9709 17.5921 32.7642 17.454 32.5366 17.3598C32.3091 17.2655 32.0652 17.2171 31.819 17.2171L21.2124 17.2171C20.715 17.2171 20.2381 17.4147 19.8864 17.7663C19.5347 18.118 19.3371 18.595 19.3371 19.0923C19.3371 19.5897 19.5347 20.0667 19.8864 20.4183C20.2381 20.77 20.715 20.9676 21.2124 20.9676L27.2921 20.9676L17.7652 30.4944C17.0334 31.2263 17.0334 32.4142 17.7652 33.1461Z",
    fill: "#F9FBFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 25C45 36.0457 36.0457 45 25 45C13.9543 45 5 36.0457 5 25C5 13.9543 13.9543 5 25 5C36.0457 5 45 13.9543 45 25ZM7 25C7 34.9411 15.0589 43 25 43C34.9411 43 43 34.9411 43 25C43 15.0589 34.9411 7 25 7C15.0589 7 7 15.0589 7 25Z",
    fill: "#F9FBFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIconW);
export default __webpack_public_path__ + "static/media/arrow-icon-w.f2e03090d5c7b3ac877c2b6bc8c6a6d4.svg";
export { ForwardRef as ReactComponent };